import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const StyledLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: ${colors.gray900};
  letter-spacing: 0.02em;
`;
